'use client';

import { GirlTravelCountries } from '@/components/girl/girl-travel-countries';
import TravelCostCalculator from '@/components/girl/travel-cost-calculator';
import { useLanguage } from '@bells/core/i18n';
import {
  attendantSedCardMobilityStatus,
  attendantSedCardWhere,
} from '@bells/i18n';
import { AttendantSearchSingleResponse } from '@bells/schema/models/attendant';
import { MobilityStatuses, VisitStatuses } from '@bells/types/attendant';
import { Badge } from '@bells/ui/components/badge';
import { Card, CardContent, CardHeader } from '@bells/ui/components/card';
import { useMemo } from 'react';

export const GirlLocation = ({
  data,
}: {
  data?: AttendantSearchSingleResponse;
}) => {
  const { language } = useLanguage();

  const visits = useMemo(() => {
    return VisitStatuses(language);
  }, [language]);

  const mobilityStatuses = useMemo(() => {
    return MobilityStatuses(language);
  }, [language]);

  return (
    <div className='grid grid-cols-1'>
      <TravelCostCalculator slug={data?.slug}></TravelCostCalculator>

      {data && data.visits != null && data.visits.length > 0 && (
        <Card className='m-0 w-full border-0 bg-transparent p-0 shadow-none'>
          <CardHeader className='px-0'>
            <h3 className='font-semibold leading-none tracking-tight'>
              {attendantSedCardWhere()}
            </h3>
          </CardHeader>
          <CardContent className='flex w-full flex-col gap-6 space-y-4 px-0'>
            <div className='inline-flex flex-wrap gap-2 font-medium'>
              {data.visits.map((df) => {
                return (
                  <Badge
                    className='break-all text-[14px] font-normal'
                    variant={'outline'}
                    key={df}
                  >
                    {visits[df]}
                  </Badge>
                );
              })}
            </div>
          </CardContent>
        </Card>
      )}

      {data &&
        data.mobilityStatus != null &&
        data.mobilityStatus.length > 0 && (
          <Card className='m-0 w-full border-0 bg-transparent p-0 shadow-none'>
            <CardHeader className='px-0'>
              <h3 className='font-semibold leading-none tracking-tight'>
                {attendantSedCardMobilityStatus()}
              </h3>
            </CardHeader>
            <CardContent className='flex w-full flex-col gap-6 space-y-4 px-0'>
              <div className='inline-flex flex-wrap gap-2 font-medium'>
                {data.mobilityStatus.map((df) => {
                  return (
                    <Badge
                      className='break-all text-[14px] font-normal'
                      variant={'outline'}
                      key={df}
                    >
                      {mobilityStatuses[df]}
                    </Badge>
                  );
                })}
              </div>
            </CardContent>
          </Card>
        )}

      <GirlTravelCountries data={data}></GirlTravelCountries>
    </div>
  );
};
